const  router = [
	{
		path: "/course/layout",
		component: () => import('../../../pages/course/Layout.vue'),
		meta: {title: '课程'},
		name: 'courseIndex',
		children:[
			{
				path: "/course",
				component: () => import('../../../pages/course/Course.vue'),
				meta: {title: '课程列表', type:'m', permission: 'courseIndex'},
				name: 'courseIndex',
			},
			{
				path: "/course/edit",
				component: () => import('../../../pages/course/EditCourse.vue'),
				meta: {title: '编辑课程', type:'c', permission: 'course_edit'},
				name: 'course_edit'
			},
			{
				path: "/course/order",
				component: () => import('../../../pages/course/Order.vue'),
				meta: {title: '课程订单', type:'c', permission: 'course_order'},
				name: 'course_order',
			},
		],
	}
];

export default router